export default __webpack_public_path__ + "static/8_16-48a67af51f4279d016a5fdf793ec962c.png";